import Utils from '@core/utils/utils';
import * as _ from 'lodash';
import * as moment from 'moment';

export function getDataLocalStorageByKey(key: string) {
  if (localStorage.getItem(key) && localStorage.getItem(key) !== 'null') {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return [];
  }
}

export const CATALOG = {
  // lấy danh sách chi nhánh
  listSite: getDataLocalStorageByKey('listSite').map(v => ({ ...v, key: v.id, value: `${v.code}-${v.name}` }))
}


export function reloadCatalog(key: string) {
  switch (key) {
    case 'listSite':
      // Lấy về danh sách RM
      CATALOG.listSite = getDataLocalStorageByKey('listSite').map(v => ({ ...v, key: v.id, value: `${v.code}-${v.name}` }));
      break;
  }
}


// lấy thông tin user
export function getUserInfo() {
  return getDataLocalStorageByKey('UI');
}

// conver date
// hàm có 2 param truyền vào
// value là giá trị ngày truyền vào dạng milisecond
// dateType là dạnh ngày mong muốn convert thành
export function converToDate(value, dateType: string) {
  if (value) {
    return moment(value).format(dateType);
  }
  return null;
}

// hàm convertdate chuyển đổi từ dạng ngày có định dạng là dateFrom(VD: YYYY-MM-DD) thành dạng dateTo(VD: DD/MM/YYYY)
export function converDateToDate(value, dateFrom: string, dateTo: string) {
  if (value) {
    return moment(value, dateFrom).format(dateTo);
  }
  return null;
}

export function formatStringEscape(str: any) {
  return JSON.stringify(str);
}

/*
*Hàm convert date lấy về từ server
*Dạng date lấy về là dạng yyymmdd(dạng ngày không có phân cách)
*/
export function convertDateFromServer(date: string) {
  if (date) {
    return date.slice(0, 4) + '/' + date.slice(4, 6) + '/' + date.slice(6);
  }
  return null;
}

/*
*Hàm convert date lấy về từ server có dạng DD/MM/YYYY
*Dạng date trả về là dạng YYYY-MM-DD
*/
export function convertDateVNO(date: string) {
  if (date) {
    const lstDate = date.split('/');
    return lstDate[2] + '-' + lstDate[1] + '-' + lstDate[0];
  }
  return null;
}


/*
*Hàm convert date để gửi data dạng date lên server
*Dạng date gửi đi là dạng yyymmdd(dạng ngày không có phân cách)
*Dạng date convert là yyyy-mm-dd
*/
export function convertDateSendServer(date: string) {
  if (date) {
    return date.split('-').join('');
  }
  return null;
}

/*
  *Hàm so sánh 2 string
  */
export function jsonObjEqual(job: any, jobN: any): boolean {
  return _.isEqual(job, jobN);
}

export function turnAlphanumberic(sText: string, pattern?: RegExp): string {
  let sNewText = sText;
  sNewText = Utils.removeVNAccent(sNewText);
  if (pattern) sNewText = Utils.removeSpecialChar(sNewText, pattern);
  else sNewText = Utils.removeSpecialChar(sNewText);
  return sNewText;
}

// Kiểm tra xem có property trong object tồn tại không
export function checkNonItemObject(obj) {
  for (let key in obj) {
    if (obj[key])
      return true;
  }
  return false;
}

// Kiểm tra xem tất cả property trong object tồn tại không
export function checkFullItemObject(obj) {
  for (let key in obj) {
    if (!obj[key])
      return true
  }
  return false;
}


// Kiểm tra xem tất cả property trong object tồn tại không
export function checkFullItemObjectData(obj) {
  for (let key in obj) {
    if (obj[key] && obj[key] !== '')
      return false
  }
  return true;
}

